import { render, staticRenderFns } from "./appendix.vue?vue&type=template&id=6d95bb7c&scoped=true&"
import script from "./appendix.vue?vue&type=script&lang=js&"
export * from "./appendix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d95bb7c",
  null
  
)

export default component.exports